




import Vue from 'vue'
import Component from 'vue-class-component'
import ResidentPaymentMethods
  from '@/views/app/management/residents/resident-page/components/ResidentPaymentMethods.vue'

@Component({
  components: { ResidentPaymentMethods }
})
export default class ResidentAgingTab extends Vue {

}
